import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment/moment';
import update from 'immutability-helper';
import { Col, Row } from 'react-bootstrap';
import RunSearch from './components/RunSearch';
import RunsTable from './components/RunsTable';
import { createRunsListBreadcrumb } from '../../shared/utils/breadcrumbs';
import {
    clearErrorMessage,
    getRunSearchForm,
    getIsFetching,
    getRuns,
    loadRuns,
    storeSearch,
    INITIAL_RUN_SEARCH_FORM,
} from '../../modules/runs/duck';

class RunsList extends React.Component {
    componentWillUnmount() {
        this.props.clearErrorMessage();
    }

    handleChange = e => {
        const form = update(this.props.runsSearchForm, {
            [e.target.name]: { $set: e.target.value },
        });
        this.props.storeSearch(form);
    };

    handleDateChange = date => {
        const form = update(this.props.runsSearchForm, {
            runDate: {
                $set: date,
            },
        });
        this.props.storeSearch(form);
    };

    handleSubmit = e => {
        e.preventDefault();
        const preparedForm = this.prepareFormDataForPost(this.props.runsSearchForm);
        this.props.loadRuns(preparedForm);
    };

    handleReset = () => {
        this.props.storeSearch(INITIAL_RUN_SEARCH_FORM);
    };

    prepareFormDataForPost = form => {
        return update(form, {
            runDate: {
                $set: form.runDate ? moment(form.runDate).format('YYYY-MM-DD') : '',
            },
        });
    };

    render() {
        const { isFetching, runs, runsSearchForm, onRunClick } = this.props;

        return (
            <div>
                {createRunsListBreadcrumb()}
                <Row>
                    <Col sm={12}>
                        <RunSearch
                            search={runsSearchForm}
                            handleChange={this.handleChange}
                            handleDateChange={this.handleDateChange}
                            handleSubmit={this.handleSubmit}
                            handleReset={this.handleReset}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <RunsTable
                            runs={runs}
                            isFetching={isFetching}
                            onRunClick={onRunClick || this.props.route.onRunClick}
                            sortName={runsSearchForm.sortParam}
                            sortOrder={runsSearchForm.sortDirection}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

RunsList.propTypes = {
    onRunClick: PropTypes.func,
};

export default withRouter(
    connect(
        state => ({
            runs: getRuns(state),
            runsSearchForm: getRunSearchForm(state),
            isFetching: getIsFetching(state),
        }),
        {
            loadRuns,
            storeSearch,
            clearErrorMessage,
        }
    )(RunsList)
);
